
export default {
    props: {
        title: String,
        educator: String,
        subtitle: String,
    },
}
